module.exports = __webpack_public_path__ + "static/media/incident_switch_mobile_en.120c5f0f.png";